import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=8b756b50&scoped=true&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=8b756b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b756b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b756b50')) {
      api.createRecord('8b756b50', component.options)
    } else {
      api.reload('8b756b50', component.options)
    }
    module.hot.accept("./DashboardNavbar.vue?vue&type=template&id=8b756b50&scoped=true&", function () {
      api.rerender('8b756b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DashboardNavbar.vue"
export default component.exports